import React from "react";
import PropTypes from "prop-types"
import {Table, Badge} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination, makeDefaultFilters} from "../../util/Util";

const PersonTable = ({dataSource, onSelectChange, loading, compact}) => {

    console.log("WE FILTER THESE", dataSource)
    const columns = [
        {
            title: 'Country',
            dataIndex: 'country',
            filters: makeDefaultFilters(dataSource, d => d.country),
            width:95
        },
        {
            title: 'aPureBase Id',
            dataIndex: 'apurebaseId',
            render: (text, record) => <NavLink to={`/person/${record.id}`}>{text}</NavLink>, width:105
        },
        {
            title: 'Status',
            dataIndex: 'active',
            render: active => <Badge status={active ? 'success' : 'default'}/>, width:60
        },
        {title: 'First Name', dataIndex: 'firstName', key: 'firstName', width: 125},
        {title: 'Last Name', dataIndex: 'lastName', key: 'lastName', width: 125},
        {
            title: 'Title',
            dataIndex: 'title',
            filters: makeDefaultFilters(dataSource, d => d.title),
            onFilter: (value, record) => record.title === value,
            width: 75
        },
        {
            title: 'Person type',
            dataIndex: 'persType',
            filters: makeDefaultFilters(dataSource, d => d.persType),
            onFilter: (value, record) => record.persType === value,  width: 150
        },
        {title: 'Specialties', dataIndex: 'specialties', key: 'specialties', width:200},
        {title: 'Primary Affiliation', dataIndex: 'siteName', key: 'siteName', compact: true,  width:200},
        {title: 'Address Info', dataIndex: 'addressInfo', key: 'addressInfo', compact: true, width: 150}
    ].filter(c => !(compact && c.compact));
    
    if (compact) {
        //columns.push({title: '', render: (text, record, index) => <NavLink to={`/person/${record.apurebaseId}`}>More</NavLink>})
    }
    
    const rowSelection = onSelectChange ? {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRowKeys[0])
        }
    } : null;
    
    return <Table dataSource={dataSource}
                  columns={columns} loading={loading}
                  rowKey={record => record.id}
                  rowSelection={rowSelection}
                  bordered pagination={defaultPagination()}
                  size="small"
                  onRow={(record) => ({
                      onContextMenu: () => {
                          console.log(record)
                      }
                  })
                  }/>
};

PersonTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired
};

export default PersonTable


// WEBPACK FOOTER //
// ./src/js/browse/person/PersonTable.js